import type { FaireProductEntity } from "../../entity_types/product";

export const p_snxwcsuejk: FaireProductEntity = {
  token: "p_snxwcsuejk",
  type: "product",
  name: "DRIED FRUIT | MANGO SLICES",
  brandName: "Hawaiian Sweets",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/81c5e5c4e230d3b29f6d6dcb6578e36a9023e7299474c535b9bbb2972f2b70c5.png",
  priceDollars: 5.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c665126c08e065f795a95eeaa5c538ef7ae31bd46bff34bce1b7ecda4131f082.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
